import { Box, Button, Container, Grid, TextField, Typography } from '@mui/material';
import { SettingsOverscan } from '@mui/icons-material';
import QuestionsTextAreaArena251 from '../QuestionsLiveArena251';
import { useState } from 'react';

const questions = [
	{ title: 'Pergunta 1', id_pesquisa: 1008 },
	{ title: 'Pergunta 2', id_pesquisa: 1009 },
	{ title: 'Pergunta 3', id_pesquisa: 1010 },
];

export default function VideoSectionLiveRevalida251() {
	const [userEmail, setUserEmail] = useState('');
	const [removeBlur, setRemoveBlur] = useState(false);

	const validateEmail = (email) => {
		const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return regex.test(email);
	};

	const handleAccessLive = () => {
		const isValidEmail = validateEmail(userEmail);
		if (isValidEmail) {
			//-- Set Logics to send lead

			return setRemoveBlur(true);
		}

		if (!isValidEmail) {
			alert('Email inválido');
		}
	};

	return (
		<Container
			fixed
			maxWidth="md"
			disableGutters={true}
			className={'revalida'}
			sx={{
				position: 'relative',
			}}
		>
			{!removeBlur && (
				<Box
					sx={{
						position: 'absolute',
						top: 0,
						left: { xs: 0, md: -25 },
						zIndex: 999,

						display: 'flex',
						justifyContent: 'center',

						width: { xs: '100%', md: '105%' },
						height: '100%',

						paddingTop: 10,

						backdropFilter: 'blur(15px)',
					}}
				>
					<Box
						sx={{
							width: { xs: '100%', md: 'calc(100vw - 65%)' },
							maxWidth: '650px',
							height: 'fit-content',
							backgroundColor: '#F5F5F5',
							padding: { xs: '24px', md: '32px' },
							borderRadius: '24px',
							marginX: 2,
						}}
					>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								flexDirection: 'column',
								gap: '32px',

								width: '100%',
								height: 'fit-content',
								backgroundColor: '#EBEBEB',
								borderRadius: '24px',
								padding: { xs: '24px', md: '32px' },
							}}
						>
							<Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 1 }}>
								<Typography
									variant={'h2'}
									fontFamily={'Poppins'}
									color={'#040404'}
									fontSize={{ xs: '20px', md: '24px' }}
									fontWeight={600}
									lineHeight={1}
									textAlign={'center'}
								>
									Acompanhe a live Desafios dos Imbatíveis!
								</Typography>
								<Typography
									variant={'h6'}
									fontFamily={'Poppins'}
									color={'#303030'}
									fontSize={{ xs: '14px', md: '16px' }}
									fontWeight={400}
									lineHeight={1}
									textAlign={'center'}
								>
									Utilize seu email de inscrição para assistir a live.
								</Typography>
							</Box>

							<TextField
								onChange={(e) => setUserEmail(e.target.value)}
								fullWidth
								type={'email'}
								variant={'outlined'}
								label={'Email utilizado na inscrição'}
								sx={{
									backgroundColor: '#FFFFFF',
									fontFamily: 'Poppins !important',

									'.MuiOutlinedInput-root': {
										fontFamily: 'Poppins',
									},

									'.MuiFormLabel-root': {
										fontFamily: 'Poppins',
									},
								}}
							/>

							<Button
								onClick={() => handleAccessLive()}
								sx={{
									width: { xs: '100%', md: '70%' },
									borderRadius: 32,
									paddingX: 5,
									fontFamily: 'Poppins',
									fontSize: '14px',
									color: 'white',
									textTransform: 'none',
								}}
								className={'background-revalida-ldl'}
							>
								Acessar live
							</Button>
						</Box>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								flexDirection: 'column',
								gap: 2,
								paddingX: '32px',
								paddingTop: '24px',
							}}
						>
							<Typography
								variant={'h2'}
								fontFamily={'Poppins'}
								color={'#040404'}
								fontSize={'16px'}
								fontWeight={400}
								lineHeight={1}
							>
								Ainda não é inscrito?
							</Typography>

							<Button
								onClick={() => {
									window.open('https://hardworkmedicina.com.br/cadastro', '_blank');
								}}
								sx={{
									width: { xs: '100%', md: '70%' },
									borderRadius: 32,
									paddingX: 5,
									fontFamily: 'Poppins',
									fontSize: '14px',
									color: 'white',
									textTransform: 'none',
									backgroundColor: '#101010',

									'&:hover': {
										backgroundColor: '#202020',
									},
								}}
							>
								Confirmar cadastro
							</Button>
						</Box>
					</Box>
				</Box>
			)}
			<Grid
				container
				className={'section'}
				sx={{
					justifyContent: 'center',
					alignItems: 'center',
					marginBottom: 0,
				}}
			>
				<Box
					sx={{
						paddingY: 2,
					}}
				>
					<Typography
						variant={'h4'}
						fontFamily={'Poppins'}
						fontSize={{ xs: '12px', md: '16px' }}
						color={'#CCCCCC'}
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							gap: 0.5,
						}}
					>
						{'Dica: clique no'}{' '}
						<SettingsOverscan sx={{ width: { xs: 14, md: 16 }, height: { xs: 14, md: 16 } }} />{' '}
						{'do player para assistir em tela cheia'}
					</Typography>
				</Box>
				<Grid
					container
					xs={12}
					sx={{
						position: 'relative',
						width: '100%',
						height: 0,
						paddingBottom: '56%',
						justifyContent: 'center',
						alignItems: 'center',
						borderRadius: { xs: '16px', md: '24px' },
						overflow: 'hidden',
					}}
				>
					<iframe
						src="https://www.youtube.com/embed/okb4sWzo7xM?si=P1OVuwlYGxpCh3UH"
						title="YouTube video player"
						allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						style={{
							position: 'absolute',
							width: '100%',
							height: '100%',
							left: 0,
							top: 0,
							border: 0,
						}}
					></iframe>
				</Grid>
			</Grid>
			<Box
				className={'section'}
				sx={{
					paddingY: 4,
				}}
			>
				<Typography
					variant={'h4'}
					fontFamily={'Poppins'}
					fontSize={'20px'}
					fontWeight={500}
					color={'#FFFFFF'}
				>
					Desafio dos Imbatíveis
				</Typography>
				<Typography
					variant={'h4'}
					fontFamily={'Poppins'}
					fontSize={'16px'}
					fontWeight={400}
					lineHeight={1.2}
					color={'#9E9E9E'}
				>
					Responda as questões abaixo apenas quando solicitado na live.{' '}
				</Typography>
				<Box>
					{questions?.map((q) => (
						<QuestionsTextAreaArena251
							title={q?.title}
							idPesquisa={q?.id_pesquisa}
						/>
					))}
				</Box>
			</Box>
		</Container>
	);
}
